export enum TYPE {
  SESSION,
  LOCAL,
}

export const storageEngine = (type: TYPE): Storage =>
  type === TYPE.SESSION ? window.sessionStorage : window.localStorage;
